var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.currUrl)?_c('audio',{ref:"audio",attrs:{"id":"uuidAudio","src":_vm.currUrl},on:{"canplay":_vm.canplay,"timeupdate":_vm.timeupdate,"ended":_vm.ended,"pause":_vm.pause}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5069fbd0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/plugins/audio.vue
// module id = 1333
// module chunks = 382